export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] sm:min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20waves%20in%20sage%20green%20terracotta%20and%20warm%20beige%20tones%2C%20flowing%20organic%20shapes%20creating%20a%20calm%20modern%20backdrop%2C%20subtle%20linen%20texture%20overlay%20throughout%2C%20editorial%20minimalism%20with%20sophisticated%20artistic%20atmosphere%2C%20gentle%20diffused%20lighting%20with%20no%20harsh%20shadows%2C%20elegant%20neutral%20composition%20suitable%20for%20fashion%20and%20lifestyle%20branding&width=1600&height=900&seq=hero-bg-v2-2026&orientation=landscape"
        alt="Sugargoo Spreadsheet background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-28 pb-20 md:pt-32 md:pb-24">
        <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-xs font-medium text-background-50/90 tracking-wide">UPDATED 2026 DATABASE</span>
        </div>

        <h1 className="font-heading text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          The Ultimate <strong className="text-primary-300">Sugargoo Spreadsheet</strong> For Smart China Shopping
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Find updated Sugargoo Spreadsheet resources, trending products, QC information, shipping guides, discount codes, and expert reviews — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            Explore Sugargoo Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm rounded-full hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            Visit Main Website
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {['Updated Database', 'Beginner Friendly', 'Shopping Guides', 'Product Research'].map((badge) => (
            <div key={badge} className="flex items-center gap-1.5 text-background-50/70 text-xs">
              <i className="ri-check-line text-accent-300 text-sm"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}